/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AbsorbedDoseToWater } from './AbsorbedDoseToWater';
import {
    instanceOfAbsorbedDoseToWater,
    AbsorbedDoseToWaterFromJSON,
    AbsorbedDoseToWaterFromJSONTyped,
    AbsorbedDoseToWaterToJSON,
} from './AbsorbedDoseToWater';

/**
 * @type AnalysisResultDtoBeamDoseOutput
 * 
 * @export
 */
export type AnalysisResultDtoBeamDoseOutput = AbsorbedDoseToWater;


export function AnalysisResultDtoBeamDoseOutputFromJSON(json: any): AnalysisResultDtoBeamDoseOutput {
    return AnalysisResultDtoBeamDoseOutputFromJSONTyped(json, false);
}

export function AnalysisResultDtoBeamDoseOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisResultDtoBeamDoseOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...AbsorbedDoseToWaterFromJSONTyped(json, true) };
    return  AbsorbedDoseToWaterFromJSONTyped(json, true);
}

export function AnalysisResultDtoBeamDoseOutputToJSON(value?: AnalysisResultDtoBeamDoseOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfAbsorbedDoseToWater(value)) {
        return AbsorbedDoseToWaterToJSON(value as AbsorbedDoseToWater);
    }

    return {};
}

/**
 * Check if a given object implements the AnalysisResultDtoBeamDoseOutput interface.
 */
export function instanceOfAnalysisResultDtoBeamDoseOutput(value: any): value is AnalysisResultDtoBeamDoseOutput {
    if (instanceOfAbsorbedDoseToWater(value)) return true;
    return false;
}

